/**
 * A catalog node's production span: `2024`, `2019–2024`, `2019–` or `–2024`. Null when the catalog
 * states neither end. Every surface that prints a span reads this, so a generation reads the same
 * on a list, a breadcrumb, a select option and a detail header.
 */
export const formatCatalogYears = (yearFrom?: number | null, yearTo?: number | null): string | null => {
  if (yearFrom == null && yearTo == null) {
    return null;
  }
  if (yearFrom != null && yearTo != null) {
    return yearFrom === yearTo ? String(yearFrom) : `${yearFrom}–${yearTo}`;
  }
  if (yearFrom != null) {
    return `${yearFrom}–`;
  }
  return `–${yearTo}`;
};
